import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    MemoryRouter,
    Redirect,
    Link
  } from "react-router-dom";
import './Recharge.css';
import Quiz from './Quiz.json';
import moment from 'moment';
import axios from 'axios';
import Loading from '../../Components/Loading/Loading';
import Card from 'react-credit-cards';
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatFormData,
  } from '../../Components/utils';
import 'react-credit-cards/es/styles-compiled.css';
import NumberFormat from 'react-number-format';
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";
import DateTime from 'react-datetime';

import InputCVV from './InputCVV';

import { transactionID } from "../../services/helpers";


const MySwal = withReactContent(Swal);


class ProgramStep extends Component {
    

    constructor(){
        super(); 


        let clientInfo = JSON.parse(localStorage.getItem('clientInfo'));
        

        //console.log(localStorage.getItem('clientInfo'));
        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo.accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            clientInfo: clientInfo,
            loading: 0,
            currentStep: 0,
            openDateTime: 0,
            chooseNumber: {
                homeHistory: [],
                bundleInfo: []
            },
            chooseAmount: [],
            chooseCreditcard: [],
            createRecharge: {
                number: 0,
                amount: 0,
                note: '',
                paymentType: '',
                paymentId: 0,
                paymentFlag: '',
                paymentLastNumber: '',
                scheduledRecharge: 0,
                cvv: 0
            },
            focused: '',
            cardData: {
                type: '',
                name: '',
                number: '',
                expiry: '',
                cvv: '',
                cpf: ''
            },
            lastRecharge: {
                number: '',
                amount: '',
                paymentId: 0,
                paymentFlag: '',
                paymentLastNumber: ''
            },
            cpf: "",
            showPopUpSucess: false,
            redirect: false

        }

        this.changePage = this.changePage.bind(this);
    }

    componentDidMount() {
        
        this.setState({loading: 1});

        axios.post('https://www.pagtel.com.br/Hub360Correios/v3/topUpHistory', {
            transactionId:  transactionID('ABT'),
            msisdn: this.state.clientInfo.number,
            year:moment().format('YYYY'),
            month:'03'
        }).then((response) => {

            if(typeof response.data.details !== 'undefined') {
                let output = {};
                let amount;
                let recharge;
                response.data.details.map((result) => {
                    let oldDate = '';
                    if(result.rechargeStatus === 'Sucesso' && (result.date > oldDate) ){
                        let oldDate = moment(result.date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                        output = result;
                    }
                });

                amount = typeof output.rechargeValue !== "undefined" ? output.rechargeValue : 0;


                recharge = {
                    number: this.formatPhone(this.state.clientInfo.number),
                    amount: amount,
                    paymentMethod: '',
                }

                this.setState({lastRecharge: recharge, loading: 0});
                
            }

        });
        
    }

    formatReal( int )
    {
        var tmp = int+'';
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if( tmp.length > 6 )
                tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

        return `R$${tmp}`;
    }

    formatPhone(phone) {
        if(phone !== 0) return phone.length > 11 ? phone.slice(2) : phone;
        return "";
    }

    validCpf = (strCPF) => {
        let Soma;
        let Resto;
        Soma = 0;
      if (strCPF == "00000000000") return false;
         
      for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
       
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;
       
      Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
       
        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
        return true;
    }

    handleCheckboxCcheduled = event => {
        this.setState({ createRecharge: {...this.state.createRecharge, scheduledRecharge: event.target.checked} })
    }

    getValues() {
        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/GetValues', {
        transactionId:  transactionID('ABT'),
        MSISDN: this.state.clientInfo.number
        }).then((response) => {
            //console.log(response);
            this.setState({chooseAmount: response.data.valueList, loading: 0 });
        });
    }

    chooseNumber(number) {
        this.setState({createRecharge: {...this.state.createRecharge, number: number}, loading: 1});
        this.getValues();
        this.steps('next');
    }

    chooseAmount(amount, note) {
        this.setState({createRecharge: {...this.state.createRecharge, amount: amount,note: note}, loading: 0});
        this.steps('next');
    }

    resetDisplayPaymentMethod(){
        let displayCreditCard = document.querySelector('.choose-creditcard');
        let displayAddCreditCard = document.querySelector('.display-add-card');
        let displayDebitCard = document.querySelector('.choose-debitcard');

        let chooseMethod = document.querySelector('.choose-method');

        displayCreditCard.classList.add('d-none');
        displayCreditCard.classList.add('d-none');
        displayCreditCard.classList.add('d-none');

        chooseMethod.classList.remove('d-none');
    }

    choosePaymentMethod(paymentMethod) {
        this.setState({
            createRecharge: {
                ...this.state.createRecharge, 
                paymentType: paymentMethod.paymentType, 
                paymentId: paymentMethod.paymentID, 
                paymentFlag: paymentMethod.flag,
                paymentLastNumber: paymentMethod.digFour
            }, 
            loading: 0
        });
        this.steps('next');

        this.resetDisplayPaymentMethod();
        
    }

    notification(type, message) {
        const title = type === 'error' ? 'Error!' : 'Sucesso!';
        Swal.fire({
            title: title,
            text: message,
            type: type
        });
        return false;
    }

    validCard(){

        const {number, name, expiry, cvv, cpf} = this.state.cardData;
        const {amount} = this.state.createRecharge;

        if(number === "" || number.length < 16 ){
            this.notification('error', 'Escolha o cartão!')
            return false;
        }

        if(name === ""){
            this.notification('error', 'Escolha o nome do titular!')
            return false;
        }

        if(expiry === "" || expiry.length < 4){
            this.notification('error', 'Escolha a data de vencimento!')
            return false;
        }

        if(expiry.slice(0, 2) < 1 || expiry.slice(0, 2) > 12){
            this.notification('error', 'Data de vencimento inválida!')
            return false;
        }

        if(amount === 0){
            this.notification('error', 'Escolha o valor da recarga!')
            return false;
        }

        if(cvv === "" || cvv.length === 0){
            this.notification('error', 'Digite o CVV!')
            return false;
        }

        if(!this.validCpf(cpf)){
            this.notification('error', 'CPF inválido!')
            return false;
        }

        return true;

    }

    addDebitcard() {

        if(!this.validCard()){
            return false;
        };

        this.setState({loading: 1});

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/addCard', {
        transactionId:  transactionID('ABU'),
        msisdn: this.state.clientInfo.number,
        paymentType: "D",
        cardNumber: this.state.cardData.number,
        expiration: this.state.cardData.expiry,
        cvv: this.state.cardData.cvv,
        cpf: this.state.cardData.cpf,
        name: this.state.cardData.name

        }).then((response) => {

            this.setState({loading: 0});

            switch(response.data.code) {
                case 'P00':

                    let numberCard = this.state.cardData.number;

                    let lastFourNumber = numberCard.substring(numberCard.length -4);
                    let cardFlag = '';

                    switch(this.state.cardData.number.substring(0, 1)) {
                        case '4':
                            cardFlag = 'Visa';
                            break;
                        case '5':
                            cardFlag = 'Mastercard';
                            break;
                        default:
                            cardFlag = '';
                            break;
                    }

                    let cardText = `${cardFlag} ${lastFourNumber}`;

                    this.setState({
                        createRecharge: {
                            ...this.state.createRecharge, 
                                paymentId: response.data.paymentID, 
                                paymentFlag: cardFlag,
                                paymentLastNumber: lastFourNumber,
                                paymentType: 'D'
                        },
                        loading: 0 
                    });

                    this.steps('next');
                    break;

                default:
                    
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    });

                    break;
            }
            
        });
    }

    displayCancelCreditCard() {
        let chooseCreditcard = document.querySelector('.choose-creditcard');
        let addCreditcard = document.querySelector('.display-add-card');

        chooseCreditcard.classList.remove('d-none');
        addCreditcard.classList.add('d-none');
        //display-add-card
    }
    

    addCreditcard() {

       
        if(!this.validCard()){
            return false;
        };

        this.setState({loading: 1});

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/addCard', {
        transactionId:  transactionID('ABV'),
        msisdn: this.state.clientInfo.number,
        paymentType: "C",
        cardNumber: this.state.cardData.number,
        expiration: this.state.cardData.expiry,
        cvv: this.state.cardData.cvv,
        cpf: this.state.cardData.cpf,
        name: this.state.cardData.name

        }).then((response) => {

            switch(response.data.code) {
                case 'P00':
                    this.displayCreditCard();
                    break;

                default:
                    this.setState({loading: 0});
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    })
                    break;
            }
            
        });
    }

    displayAddCreditCard() {
        let chooseCreditcard = document.querySelector('.choose-creditcard');
        let addCreditcard = document.querySelector('.display-add-card');

        chooseCreditcard.classList.add('d-none');
        addCreditcard.classList.remove('d-none');
        //display-add-card
    }

    displayCreditCard() {

        this.setState({loading: 1});
        let chooseMethod = document.querySelector('.choose-method');
        let chooseCreditcard = document.querySelector('.choose-creditcard');
        let addCreditcard = document.querySelector('.display-add-card');
        chooseMethod.classList.add('d-none');
        chooseCreditcard.classList.remove('d-none');
        addCreditcard.classList.add('d-none');

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/GetCard', {
        transactionId:  transactionID('ABW'),
        MSISDN: this.state.clientInfo.number
        }).then((response) => {
            this.setState({chooseCreditcard: response.data.cardList, loading: 0 });
        });
    }

    displayDebitCard() {

        // this.setState({loading: 1});
        let chooseMethod = document.querySelector('.choose-method');
        let chooseDebitcard = document.querySelector('.choose-debitcard');
        chooseMethod.classList.add('d-none');
        chooseDebitcard.classList.remove('d-none');

        /* axios.post('https://www.pagtel.com.br/Hub360Correios/v2/GetCard', {
        transactionId: moment().add('3', 'seconds').unix(),
        MSISDN: this.state.clientInfo.number
        }).then((response) => {
            this.setState({chooseCreditcard: response.data.cardList, loading: 0 });
        }); */
    }

    async changePage(page) {

        this.setState({loading: 1});

        switch(page){
            case 'chooseNumber':

               await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/BundleInfo', {
                    transactionId:  transactionID('ABX'),
                    msisdn: this.state.clientInfo.number
                    }).then((response) => {
                        this.setState({chooseNumber: {...this.state.chooseNumber,  bundleInfo: response.data } });
               });
               await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/homeHistory', {
                    transactionId:  transactionID('ABY'),
                    msisdn: this.state.clientInfo.number
                }).then((response) => {
                    this.setState({chooseNumber: {...this.state.chooseNumber, homeHistory: response.data.infoDetails}, loading: 0 })
                });

                break;
        }
    }


    handleInputChange = ({ target }) => {
        //console.log(target.name);
        if (target.name === 'number') {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === 'expiry') {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === 'cvv') {
            target.value = formatCVC(target.value);
        }

        this.setState({ cardData: {...this.state.cardData, [target.name]: target.value} });

        //console.log(this.state.cardData);
    };

    handleInputFocus = ({ target }) => {
        this.setState({
            focused: target.name,
        });
    };

    getNodeindex( elm ){ 
        
        return [...elm.parentNode.children].findIndex(c => c == elm)
        // or
        return [...elm.parentNode.children].indexOf(elm)
    }

    backStep(element, step) {

        if(step < 0) {
            this.setState({redirect: true});
            return false;
        }
        let currentStep = document.querySelector('.content-recharge-step li.current');
        
        // if(this.getNodeindex(element.target) < this.getNodeindex(currentStep) || this.getNodeindex(currentStep) === 0){
            if(this.getNodeindex(currentStep) > step){
            this.steps(step);
        }
    }
    displayCreditCard_2() {

        let addCreditcard = document.querySelector('.display-add-card');
        addCreditcard.classList.add('d-none');

    }

    steps(step) {

        this.displayCreditCard_2();
        
        document.querySelectorAll('.containerRecharge .step').forEach((step) => {
            step.classList.remove('current');
        });

        document.querySelectorAll('.content-recharge-step li').forEach((step) => {
            step.classList.remove('current');
        });

        let currentStep = this.state.currentStep;

        switch(step){
            case 'next':
                if(this.state.currentStep < 3) 
                    currentStep = this.state.currentStep + 1;
                    this.setState({
                        currentStep: currentStep
                    }); 
                break;
            case 'previous':
                if(this.state.currentStep > 0) 
                    currentStep = this.state.currentStep - 1;
                    this.setState({
                        currentStep: this.state.currentStep - 1
                    }); 
                break;
            default:
                if(!isNaN(step)){

                    currentStep = step;
                    this.resetDisplayPaymentMethod();
                    switch(step){
                        case 0:
                            this.setState({
                                currentStep: step,
                                createRecharge: {
                                    ...this.state.createRecharge,
                                    number: 0,
                                    amount: 0,
                                    paymentId: '',
                                    paymentLastNumber: '',
                                    paymentFlag: '',

                                }
                            });
                            break;
                        case 1:
                            this.setState({
                                currentStep: step,
                                createRecharge: {
                                    ...this.state.createRecharge,
                                    amount: 0,
                                    paymentId: '',
                                    paymentLastNumber: '',
                                    paymentFlag: '',
                                }
                            });
                            break;
                        case 2:
                            this.setState({
                                currentStep: step,
                                createRecharge: {
                                    ...this.state.createRecharge,
                                    paymentId: '',
                                    paymentLastNumber: '',
                                    paymentFlag: '',
                                }
                            });
                            break;
                    }
                    
                    
                    
                }
                 
                break;

        }

        document.querySelectorAll('.containerRecharge .step').forEach((step, key) => {
            if(key === currentStep) step.classList.add('current');
        });

        document.querySelectorAll('.content-recharge-step li').forEach((step, key) => {
            if(key === currentStep) step.classList.add('current');
        });


    }

    changeLastRecharge(value) {

        let value1, value2
        switch(value) {
            case 'number':
                break;

            case 'amount':
                
                this.getValues();
                break;
        }

        value1 = document.querySelector(`.recharge-change-${value}-text`);
        value2 = document.querySelector(`.recharge-change-${value}-input`);

        value1.classList.add('d-none');
        value2.classList.remove('d-none');

       

    }

    changeDateTime(date){
        date = new Date(date._d);
        
        let day =  date.getDate() <= 9 ? "0"+date.getDate() : date.getDate() ,
            month = date.getMonth() + 1 <= 9 ? "0"+(date.getMonth() + 1) : date.getMonth()  + 1,
            year = date.getFullYear() 
        this.setState({createRecharge: {...this.state.createRecharge, number: JSON.parse(localStorage.getItem("clientInfo")).number, 
            nextRechargeDay: year + "-" + month  + "-" + day , 
            date: day + "/" + month}
            , loading: 1});
        this.getValues();
        this.steps('next');
    }

    fastRecharge() {
        
        let number = document.querySelector('.recharge-change-number-input').value;
        let amount = document.querySelector('.recharge-change-amount-input').value;

        amount = typeof amount === 'undefined' || amount === 0 || amount === '' ? this.state.lastRecharge.amount.replace('.', '') : amount;

       
        this.setState({
            createRecharge: {
                ...this.state.createRecharge,
                number: number,
                amount: amount
            } 
        });

        
        setTimeout(() => {this.steps(2)}, 100);
        console.log('Test');
        
    }

    sendRecharge() {

        if((this.state.cpf.length < 11)||(this.state.cpf.length === 11 && !this.validCpf(this.state.cpf))) {
            Swal.fire({
                title: 'Erro!',
                text: "Digite o CPF corretamente!",
                type: 'error'
            });
            return false;
        }
        
        this.setState({loading: 1});

      
        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/createProgramRecharge', {
            transactionId: transactionID('ABZ'),
            MSISDN: this.state.clientInfo.number,
            SMSISDN: this.state.clientInfo.number,
            paymentType: this.state.createRecharge.paymentType,
            paymentId: this.state.createRecharge.paymentId,
            Value: this.state.createRecharge.amount,
            program: this.state.createRecharge.scheduledRecharge,
            nextRechargeDay: this.state.createRecharge.nextRechargeDay,
            CPF: this.state.cpf
        }).then((response) => {
                this.setState({loading: 0});

                switch(response.data.code){
                    case 'P00':
                        this.setState({showPopUpSucess: true}); 
                        break;
                    case 'D01':
                        window.location.href = response.data.authenticationUrl;
                    break;
                    case 'P04':
                        console.log(response.data.msg);
                    break;
                    default:
                        Swal.fire({
                            title: 'Erro!',
                            text: response.data.msg,
                            type: 'error'
                        });
                        this.setState({loading: 0});   
                        break;
                        
                }

        }).catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao carregar os cartões!",
                type: 'error'
            })
            this.setState({loading: 0}); 
        });

    }

    closeAndMoveOn = () => {
        this.setState({redirect: true});
    }

    backBtn = (e) => {
        e.preventDefault();
        
        if(this.state.currentStep === 0){
            this.setState({redirect: true});
        }
        else {
            this.steps("previous");
        }

    }

    render(){

        var moment = require('moment');
        require('moment/locale/pt');
        var yesterday = moment().subtract(1, 'day' + 1);
        var valid = function( current ){
            return current.isAfter( yesterday );
        };


        if(this.state.redirect) {
            return <Redirect to={{
                pathname: "/home"
            }}/>
        }

        return (
            <div>
                <div className="rechargeSteps">

                <MemoryRouter>
                    
                    <Route exact path="/">
                        <div className="content-recharge-step" >
                            <div className="btn-back"><a onClick={(e) => {this.backStep(e, this.state.currentStep - 1)}} href="#">Voltar </a></div>
                            <ol className="progressbar">
                                <li className="current" onClick={(e) => {this.backStep(e, 0)}}>
                                    <p>{ this.state.createRecharge.number === 0 ? 'Data' : this.state.createRecharge.date }</p>
                                </li>
                                <li className="" onClick={(e) => {this.backStep(e, 1)}}>
                                    <p>{ this.state.createRecharge.amount === 0 ? 'Valor' : this.formatReal(this.state.createRecharge.amount) }</p>
                                </li>
                                <li className="" onClick={(e) => {this.backStep(e, 2)}}>
                                    <p>{ this.state.createRecharge.paymentFlag === '' ? 'Pagamento' : `${this.state.createRecharge.paymentFlag} ${this.state.createRecharge.paymentLastNumber}` }  </p>
                                </li>
                            </ol>
                            <div className="containerRecharge">

                                <div className="choose-number-container step current" >
                                    <h2>1- Selecione a data da sua recarga <br/> Você pode começar a usar o quanto antes</h2>
                                    <br />
                                    <br />
                                    <div className="center-item calendar">
                                        <DateTime 
                                            input={false}
                                            dateFormat="DD/MM/YYYY" 
                                            className={['inputDateTime']}
                                            timeFormat={false} 
                                            showToday={true}
                                            closeOnSelect={true}
                                            closeOnTab={true}
                                            isValidDate={valid}
                                            dateTime={moment().add('1', 'day')}
                                            locale={'pt'}
                                            defaultValue={moment().add('1', 'day')}
                                            onChange={(date) => {this.changeDateTime(date)}}
                                            onFocus={() => {this.setState({openDateTime: 1})}}
                                            onBlur={() => {console.log('Click OUT: ');}}
                                            open={this.state.openDateTime}
                                        />
                                    </div>
                               
                                </div>

                                <div className="choose-amount-container step " >
                                    <h2>2 - Selecione o valor da recarga</h2>
                                    <ul className="select-amount">
                                        {
                                            this.state.chooseAmount.map((response, key) => {
                                                return !response.promotion ? <li className={"cursor-pointer"} key={key} onClick={() => {this.chooseAmount(response.value, response.note)}} amount={response.value}> <img src={response.note} /> </li> : ""
                                            })
                                        }
                                    </ul>
                                </div>

                                <div className="choose-payment-method-container step">
                                    <div className="choose-method">
                                        <h2>3. E por fim, selecione a melhor Forma de pagamento :D</h2>
                                        <ul className="select-payment-method ">
                                            <li  onClick={() => {this.displayCreditCard()}}>
                                                <div className="img-select-method">
                                                    <img src={require('../../images/payments/iCredito.png')} />
                                                </div>
                                                <div>
                                                    <h4>Crédito</h4>
                                                    <img className="payment-flags" src={require('../../images/payments/flags_credit.svg')} />
                                                </div>
                                                <div className="arrow-icon" href="#"></div>
                                            </li>
                                            {/* <li>
                                                <div className="img-select-method">
                                                    <img src={require('../../images/payments/iDebito.png')} />
                                                </div>
                                                <div>
                                                    <h4>Débito</h4>
                                                    <img className="payment-flags" src={require('../../images/payments/flags_debit.svg')} />
                                                </div>
                                                <div className="arrow-icon" href="#" onClick={() => {this.displayDebitCard()}}></div>
                                            </li> */}
                                            {/* <li>
                                                <div className="img-select-method">
                                                    <img src={require('../../images/payments/boleto.svg')} />
                                                </div>
                                                <div>
                                                    <h4>Boleto</h4>
                                                </div>
                                                <div className="arrow-icon" href="#" ></div>
                                            </li> */}

                                            {/* <li>
                                                <div className="img-credit">
                                                    <img src={require('../../images/payments/iCredito.png')} />
                                                </div>
                                                <div>
                                                    <h4>PayPal</h4>
                                                    <img className="payment-flags" src={require('../../images/payments/flags.svg')} />
                                                </div>
                                                <div className="arrow-icon" href="#" ></div>
                                            </li> */}

                                        </ul>
                                    </div>

                                    
                                    <div className="d-none choose-creditcard">
                                        <h2>Selecione o cartão de crédito</h2>
                                        <ul className="select-payment-method">
                                            {   this.state.chooseCreditcard === null ?
                                                
                                                    <li>
                                                        <h3>Nenhum cartão cadastrado!</h3>
                                                    </li>
                                                
                                                :
                                                this.state.chooseCreditcard.map((response, key) => {
                                                    return (
                                                        <li  onClick={() => {this.choosePaymentMethod(response)}}  key={key}>
                                                            <div className="img-select-method">
                                                                <img src={require(`../../images/payments/${response.flag.toLowerCase()}.svg`)} />
                                                            </div>
                                                            <div>
                                                                <h4>Cartão {response.flag}</h4>
                                                                <p>Final {response.digFour}</p>
                                                            </div>
                                                            <div className="arrow-icon" href="#"></div>
                                                        </li>
                                                    );
                                                })
                                            }
                                            {/* <li>
                                                <div className="img-select-method">
                                                    <img src={require('../../images/payments/mastercard.svg')} />
                                                </div>
                                                <div>
                                                    <h4>Cartão Master</h4>
                                                    <p>Final 9019</p>
                                                </div>
                                                <div className="arrow-icon" href="#" ></div>
                                            </li>
                                            <li>
                                                <div className="img-select-method">
                                                    <img src={require('../../images/payments/visa.svg')} />
                                                </div>
                                                <div>
                                                    <h4>Cartão Visa</h4>
                                                    <p>Final 9019</p>
                                                </div>
                                                <div className="arrow-icon" href="#" ></div>
                                            </li> */}
                                        </ul>
                                        <p className="choose-number-new-number cursor-pointer" onClick={() => { this.displayAddCreditCard() }}><i className="choose-number-plan-icon icon-plus"></i> Adicionar novo cartão</p>
                                    </div>
                                    
                                    
                                    <div className="display-add-card card-container d-none">
                                        <h2>Novo Cartão de crédito</h2>
                                        <div className="card-content">
                                            <div className="content-payment-body-info">    
                                                    <form>
                                                        <label>Número do cartão</label>
                                                        <NumberFormat 
                                                            type="text"
                                                            name="number"
                                                            placeholder="5555 **** **** 7181"
                                                            required
                                                            onValueChange={(values) => {
                                                                const {value} = values;
                                                                this.setState({cardData: {...this.state.cardData, number: value}});
                                                            }} 
                                                            onFocus={this.handleInputFocus}
                                                            format="####.####.####.####"
                                                        />

                                                        <label>Nome titular</label>
                                                        <input 
                                                            type="text"
                                                            name="name"
                                                            placeholder="José da Silva"
                                                            required
                                                            onChange={this.handleInputChange}
                                                            onFocus={this.handleInputFocus}/>

                                                        <div className="both-info">
                                                            <div>

                                                                <label>Data de vencimento</label>
                                                                <NumberFormat 
                                                                    type="text"
                                                                    name="expiry"
                                                                    placeholder="04/21"
                                                                    pattern="\d\d/\d\d"
                                                                    required
                                                                    onValueChange={(values) => {
                                                                        const {value} = values;
                                                                        this.setState({cardData: {...this.state.cardData, expiry: value}});
                                                                    }} 
                                                                    onFocus={this.handleInputFocus}
                                                                    format="##/##" 
                                                                />

                                                            </div>
                                                            <div>

                                                                <label>CVV</label>
                                                                <input 
                                                                    type="text"
                                                                    name="cvv" 
                                                                    placeholder="***"
                                                                    pattern="\d{3,4}"
                                                                    required
                                                                    onChange={this.handleInputChange}
                                                                    onFocus={this.handleInputFocus}/>

                                                            </div>
                                                        </div>

                                                        <label>CPF</label>
                                                        <NumberFormat 
                                                            value={this.state.cardData.cpf} 
                                                            placeholder="123.456.789-10"
                                                            onValueChange={(values) => {
                                                                const {value} = values;
                                                                if(value.length === 11 && !this.validCpf(value)){
                                                                    Swal.fire({
                                                                        title: 'Erro!',
                                                                        text: "CPF inválido!",
                                                                        type: 'error',
                                                                        icon: 'error'
                                                                    })
                                                                    //this.setState({loading: 0}); 
                                                                }
                                                                this.setState({cardData: {...this.state.cardData, cpf: value} });
                                                                console.log(this.state.cardData);
                                                            }}  
                                                            format="###.###.###-##" 
                                                        />

                                                    </form>
                                            </div>
                                        
                                            <div className="content-payment-body-card">
                                            <Card
                                                number={this.state.cardData.number}
                                                name={this.state.cardData.name}
                                                expiry={this.state.cardData.expiry}
                                                cvc={this.state.cardData.cvv}
                                                focused={this.state.focused}
                                                callback={this.handleCallback}
                                            />
                                        </div>
                                        </div>
                                        <div className="container-btn-add">
                                            <button className="btn btn-cancel" onClick={() => {this.displayCancelCreditCard()}}>Cancelar</button>
                                            <button className="btn btn-success" onClick={() => {this.addCreditcard()}}>Salvar</button>
                                        </div>
                                    </div>

                                    <div className="choose-debitcard card-container d-none">
                                        <h2>Cartão de débito</h2>
                                        <div className="card-content">
                                            <div className="content-payment-body-info">    
                                                    <form>
                                                        <label>Número do cartão</label>
                                                        <NumberFormat 
                                                            type="text"
                                                            name="number"
                                                            placeholder="5555 **** **** 7181"
                                                            required
                                                            onValueChange={(values) => {
                                                                const {value} = values;
                                                                this.setState({cardData: {...this.state.cardData, number: value}});
                                                            }} 
                                                            onFocus={this.handleInputFocus}
                                                            format="####.####.####.####"
                                                        />

                                                        <label>Nome titular</label>
                                                        <input 
                                                            type="text"
                                                            name="name"
                                                            placeholder="José da Silva"
                                                            required
                                                            onChange={this.handleInputChange}
                                                            onFocus={this.handleInputFocus}/>

                                                        <div className="both-info">
                                                            <div>

                                                                <label>Data de vencimento</label>
                                                                <NumberFormat 
                                                                    type="text"
                                                                    name="expiry"
                                                                    placeholder="04/21"
                                                                    pattern="\d\d/\d\d"
                                                                    required
                                                                    onValueChange={(values) => {
                                                                        const {value} = values;
                                                                        this.setState({cardData: {...this.state.cardData, expiry: value}});
                                                                    }} 
                                                                    onFocus={this.handleInputFocus}
                                                                    format="##/##" 
                                                                />

                                                            </div>
                                                            <div>

                                                                <label>CVV</label>
                                                                <input 
                                                                    type="text"
                                                                    name="cvv" 
                                                                    placeholder="***"
                                                                    pattern="\d{3,4}"
                                                                    required
                                                                    onChange={this.handleInputChange}
                                                                    onFocus={this.handleInputFocus}/>

                                                            </div>
                                                        </div>

                                                        <label>CPF</label>
                                                        <NumberFormat 
                                                            value={this.state.cardData.cpf} 
                                                            placeholder="123.456.789-10"
                                                            onValueChange={(values) => {
                                                                const {value} = values;
                                                                if(value.length === 11 && !this.validCpf(value)){
                                                                    Swal.fire({
                                                                        title: 'Erro!',
                                                                        text: "CPF inválido!",
                                                                        type: 'error',
                                                                        icon: 'error'
                                                                    })
                                                                    //this.setState({loading: 0}); 
                                                                }
                                                                this.setState({cardData: {...this.state.cardData, cpf: value} });
                                                                // console.log(this.state.cardData);
                                                            }}  
                                                            format="###.###.###-##" 
                                                        />

                                                    </form>
                                            </div>
                                        
                                            <div className="content-payment-body-card">
                                            <Card
                                                number={this.state.cardData.number}
                                                name={this.state.cardData.name}
                                                expiry={this.state.cardData.expiry}
                                                cvc={this.state.cardData.cvv}
                                                focused={this.state.focused}
                                                callback={this.handleCallback}
                                            />
                                        </div>
                                        </div>
                                        <button className="btn btn-success" onClick={() => {this.addDebitcard()}}>Salvar</button>
                                    </div>
                                </div>
                                
                                <div className="purchase-resume step">
                                    {/* <h2>Resumo</h2> */}

                                    <ul className="purchase-resume-container">
                                        <li>
                                            <div className="recharge-change-number-container">
                                                <small>Valor</small>
                                                <a href="#" className="recharge-change-number" onClick={() => {this.steps(1)}}>Editar</a>
                                            </div>
                                            <div className="d-flex recharge-change-number-display">
                                                <div>
                                                    { this.state.createRecharge.amount === 0 || <img className="resume-amount-image" src={this.state.createRecharge.note} />  }
                                                </div>
                                                {/* <div>
                                                    <p>{this.formatReal(this.state.createRecharge.amount)}</p>
                                                    
                                                </div> */}
                                            </div>
                                        
                                        </li>
                                        <li>
                                            <div className="recharge-change-number-container">
                                                <small>Data da próxima recarga</small>
                                                <a href="#" className="recharge-change-number" onClick={() => {this.steps(0)}}>Editar</a>
                                            </div>
                                             <p>{(this.state.createRecharge.date)
                                        ?this.state.createRecharge.date.split("/")[0]+"/"+this.state.createRecharge.date.split("/")[1] : "" }</p>
                                        </li>
                                        <li>
                                            <div className="recharge-change-number-container">
                                                <small>Número</small>
                                                {/* <a href="#" className="recharge-change-number" onClick={() => {this.steps(0)}}>Editar</a> */}
                                            </div>
                                            <p>{this.formatPhone(this.state.clientInfo.number)}</p>
                                        </li>
                                        <li>
                                            <div className="recharge-change-number-container">
                                                <small>CPF</small>
                                                {/* <a href="#" className="recharge-change-number" onClick={() => {this.steps(0)}}>Editar</a> */}
                                            </div>
                                            <NumberFormat 
                                                className="cpfResumo"
                                                value={this.state.cpf} 
                                                placeholder="123.456.789-10"
                                                onValueChange={(values) => {
                                                    const {value} = values;
                                                    if(value.length === 11 && !this.validCpf(value)){
                                                        Swal.fire({
                                                            title: 'Erro!',
                                                            text: "CPF inválido!",
                                                            type: 'error',
                                                            icon: 'error'
                                                        })
                                                        //this.setState({loading: 0}); 
                                                    }
                                                    this.setState({cpf: value });
                                                }}  
                                                format="###.###.###-##" 
                                            />
                                        </li>
                                        <li>
                                            <div className="recharge-change-number-container">
                                                <small>Pagamento</small>
                                                <a href="#" className="recharge-change-number" onClick={() => {this.steps(2)}}>Editar</a>
                                            </div>

                                            <div className="d-flex flex-item-align-center">
                                                <div>
                                                    {
                                                        typeof this.state.createRecharge.paymentFlag !== 'undefined' 
                                                        && this.state.createRecharge.paymentFlag === '' || 
                                                        <img className="resume-payment-flag" src={require(`../../images/payments/${this.state.createRecharge.paymentFlag.toLocaleLowerCase()}.svg`)} />
                                                    }
                                                </div>
                                                <div>
                                                    Final {this.state.createRecharge.paymentLastNumber}    
                                                </div>
                                            </div>
                                            
                                            
                                        </li>
                                        <li>
                                            <div className="recharge-change-number-container">
                                                <small>Total</small>
                                                <a href="#" className="recharge-amount-total color-success">{this.formatReal(this.state.createRecharge.amount)}</a>
                                            </div>
                                        </li>
                                    </ul>
                                    
                                    
                                    <br />

                                    <button className="btn btn-success" onClick={() => {this.sendRecharge()}} style={{margin: '0 auto'}}>CONFIRMAR</button>

                                </div>
                            

                            </div>
                        </div>
                    </Route>
                </MemoryRouter>
                                                    
           
                {this.state.showPopUpSucess && 
                    <div className="container-popupsuccess">
                        <div className="PopUpSucess">
                            <i className="PopUpSucess-icon"></i>
                            <h3>Recarga agenda com sucesso!</h3>
                            <p>A sua recarga no valor de { this.formatReal(this.state.createRecharge.amount) } para o número {this.state.clientInfo.number.replace("55","")} foi agendada com sucesso 🎉</p>
                            <div className="PopUpSucess-btn" onClick={this.closeAndMoveOn}>Ok</div>
                        </div>
                        <div className="overLay-popup"></div>
                    </div>
                }
            </div>
                <Loading loading={this.state.loading} />
            </div>
        );
    }
    
}

export default ProgramStep